import { format, formatDistanceToNow } from 'date-fns';
import { formatCurrency as formatCurrencyWithMinorUnits } from './currency';

/**
 * @deprecated Use formatCurrency from './currency' instead for proper minor unit handling
 */
export function formatCurrency(cents: number, currency = 'USD'): string {
  // Delegate to the new currency utility which handles minor units correctly
  return formatCurrencyWithMinorUnits(cents, currency);
}

export function formatPercent(value: number): string {
  return `${value.toFixed(2)}%`;
}

export function formatDate(date: string | Date): string {
  return format(new Date(date), 'MMM d, yyyy');
}

export function formatDateTime(date: string | Date): string {
  return format(new Date(date), 'MMM d, yyyy h:mm a');
}

export function formatRelative(date: string | Date): string {
  return formatDistanceToNow(new Date(date), { addSuffix: true });
}

export function formatNumber(num: number): string {
  return new Intl.NumberFormat('en-US').format(num);
}
